export default class StoreController {

  constructor(app, pageId) {
    this.app = app;
    this.pageId = pageId;
  }
  show(path) {
    const app = this.app;
    const pageId = this.pageId || path;

    //get model
    const model = {
      coins: app.userdata.coins
    }

    app.populate(pageId, model);
    app.swapPage(pageId);
  }
}